export default __webpack_public_path__ + "static/media/delete.d1484791.svg";